module.exports = {"140430100":"定昌镇","140430101":"郭村镇","140430102":"故县镇","140430103":"新店镇","140430104":"漳源镇","140430105":"册村镇","140430106":"沁州黄镇","140430107":"南里镇","140430108":"松村镇","140430203":"牛寺乡","140430206":"杨安乡","140430400":"沁县现代农业产业示范区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140430.json
// module id = 391
// module chunks = 0